/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-07-24 14:38:28
 */
import { useCallback } from 'react'
import { App } from 'antd'
import { useAIRecognition } from '../context/AIRecognitionContext'

/**
 * 隐患项相关操作的自定义Hook
 */
export const useHazardItems = () => {
  const { message } = App.useApp()
  const { recognitionResult, setRecognitionResult } = useAIRecognition()

  /**
   * 更新隐患项内容
   */
  const updateHazardItem = useCallback(
    (index: number, content: string) => {
      if (!recognitionResult) return

      const newHazards = [...recognitionResult.potentialHazardList]
      newHazards[index] = content
      setRecognitionResult({
        ...recognitionResult,
        potentialHazardList: newHazards
      })
    },
    [recognitionResult, setRecognitionResult]
  )

  /**
   * 删除隐患项
   */
  const deleteHazardItem = useCallback(
    (index: number) => {
      if (!recognitionResult) return

      const newHazards = recognitionResult.potentialHazardList.filter(
        (_, i) => i !== index
      )
      setRecognitionResult({
        ...recognitionResult,
        potentialHazardList: newHazards
      })

      message.success('隐患项已删除')
    },
    [recognitionResult, setRecognitionResult]
  )

  /**
   * 添加新的隐患项
   */
  const addHazardItem = useCallback(
    (content: string) => {
      if (!recognitionResult) return

      setRecognitionResult({
        ...recognitionResult,
        potentialHazardList: [...recognitionResult.potentialHazardList, content]
      })

      message.success('隐患项已添加')
    },
    [recognitionResult, setRecognitionResult]
  )

  /**
   * 批量更新隐患项
   */
  const updateHazardItems = useCallback(
    (hazards: string[]) => {
      if (!recognitionResult) return

      setRecognitionResult({
        ...recognitionResult,
        potentialHazardList: hazards
      })
    },
    [recognitionResult, setRecognitionResult]
  )

  /**
   * 获取隐患项统计信息
   */
  const getHazardStats = useCallback(() => {
    if (!recognitionResult) {
      return { total: 0 }
    }

    return {
      total: recognitionResult.potentialHazardList.length
    }
  }, [recognitionResult])

  return {
    hazards: recognitionResult?.potentialHazardList || [],
    updateHazardItem,
    deleteHazardItem,
    addHazardItem,
    updateHazardItems,
    getHazardStats
  }
}
